import angular from 'angular';
import { httpService } from './HTTPService';
import { sessionProvider } from './Session';

/**
 * @ngdoc    overview
 * @name     csm.remoting
 * @description
 * Remote services.
 *******************************************************************************/
export default angular
  .module('csm.remoting', [])
  .service('HTTPService', httpService)
  .provider('Session', sessionProvider).name;
